import { fetchList } from "src/pages/Bundle/List/ducks"
import { Field } from "redux-form"
import { formValueSelector } from "redux-form"
import { makeStyles } from "@material-ui/core/styles"
import { reduxForm } from "redux-form"
import { useSelector, useDispatch } from "react-redux"
import { useTheme } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Card from "src/pages/Bundle/List/card"
import Divider from "@material-ui/core/Divider"
import get from "lodash/get"
import Grid from "@material-ui/core/Grid"
import InputAdornment from "@material-ui/core/InputAdornment"
import Layout from "src/features/Layout"
import Link from "@material-ui/core/Link"
import Pagination from "@material-ui/lab/Pagination"
import React, { useEffect } from "react"
import SearchIcon from "@material-ui/icons/Search"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { push } from "redux-first-history"
import _isEmpty from "lodash/isEmpty"

// TextField
const renderTextField = ({
  label,
  input,
  meta: { touched, invalid, error },
  ...custom
}) => (
  <TextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
)

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  pointer: {
    cursor: "pointer",
  },
}))

let BundleList = ({ handleSubmit, reset, ...props }) => {
  // eslint-disable-next-line
  const theme = useTheme()
  const classes = useStyles()
  const matches = useMediaQuery(theme.breakpoints.down("xs"))
  const dispatch = useDispatch()
  const selector = formValueSelector("bundleListForm")
  // limit from state of form
  const limit = useSelector((state) => selector(state, "limit"))
  const name = useSelector((state) => selector(state, "name"))
  const total = useSelector((state) => state.bundle_list.total)
  const list = useSelector((state) => state.bundle_list.list)
  const page = useSelector((state) => state.bundle_list.page)
  const isEmpty = total === 0
  const total_page = Math.ceil(total / limit)

  async function submit(values) {
    try {
      const { name, limit } = values
      dispatch(fetchList({ name, page: 1, limit }))
      return
    } catch (error) {
      // do somethings...
    }
  }

  const handleReset = async () => {
    reset()
    try {
      dispatch(fetchList({ page: 1, limit }))
    } catch (error) {
      // ...
    }
  }

  const handlePaheChange = (e, page) => {
    dispatch(fetchList({ name, limit, page: page }))
  }

  const toCreate = () => {
    dispatch(push("/bundle/create"))
  }

  useEffect(() => {
    dispatch(fetchList({ limit }))
  }, [dispatch, limit])

  // refactor เป็น __content -> ifเอาตรงนี้

  return (
    <Layout
      breadcrumbs={{
        previous: [],
        current: "List",
      }}
    >
      <Typography variant="h5" gutterBottom>
        Bundle
      </Typography>
      <form onSubmit={handleSubmit(submit)}>
        <Box my={2} className={classes.root}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={12} sm={6}>
              <Field
                name="name"
                variant="outlined"
                component={renderTextField}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                label="Label Name"
                placeholder="Search by Label Name"
                size="small"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                color="secondary"
                disableElevation
                fullWidth={matches}
                onClick={handleSubmit(submit)}
              >
                ค้นหา
              </Button>
            </Grid>
            <Grid item xs={12} sm={4}>
              {matches ? (
                <Button
                  variant="contained"
                  color="secondary"
                  disableElevation
                  fullWidth={matches}
                  onClick={toCreate}
                >
                  Create New Bundle
                </Button>
              ) : (
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    color="secondary"
                    disableElevation
                    fullWidth={matches}
                    onClick={toCreate}
                  >
                    Create New Bundle
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
        <Grid container alignItems="center">
          <Box mr={1}>Result {total}</Box>
          <Divider orientation="vertical" flexItem />
          <Box ml={1}>
            <Typography
              className={classes.pointer}
              component={Link}
              color="primary"
              variant="caption"
              underline="none"
              onClick={handleReset}
            >
              Reset
            </Typography>
          </Box>
        </Grid>
        <Box my={1}>
          {isEmpty ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              m={2}
              p={2}
            >
              No results found
            </Box>
          ) : (
            list.map((record) => {
              const _id = get(record, "_id", "")
              const label = get(record, "name", "")
              const description = get(record, "detail", "")
              const medicine = get(record, "medicine", []).filter(
                (el) => !_isEmpty(el)
              )
              const supply = get(record, "supply", []).filter(
                (el) => !_isEmpty(el)
              )
              const total_item = medicine.length + supply.length
              const promo_price = get(record, "promo_price", 0)
              const cover_uri = get(record, "cover_img", "")
              const end_date = get(record, "end_date")

              return (
                <Card
                  key={_id}
                  id={_id}
                  label={label}
                  description={description}
                  total_item={total_item}
                  promo_price={promo_price}
                  cover_uri={cover_uri}
                  end_date={end_date}
                />
              )
            })
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 1,
            m: 1,
          }}
        >
          <Pagination
            count={total_page}
            color="primary"
            page={page}
            onChange={handlePaheChange}
          />
        </Box>
      </form>
    </Layout>
  )
}

BundleList = reduxForm({
  form: "bundleListForm",
  // enableReinitialize: true,
  initialValues: {
    name: "",
    limit: 10,
  },
})(BundleList)

export default BundleList
